/* Eureka! — correzioni puntuali di comportamento.
   File: assets/eureka-correzioni.js   ·   caricato con defer.

   Come per il CSS gemello: ogni blocco dice cosa corregge e perche', e va
   tolto da qui quando la correzione rientra nel file di origine.
   ========================================================================= */

/* --------------------------------------------------------------------------
   1. Filtri di collezione: un pannello alla volta

   Sintomo: aprendo un secondo filtro il primo resta aperto e i due pannelli
   si sovrappongono.

   Causa: lo script che gestisce l'esclusione vive in snippets/eu-filtri.liquid
   e comincia con

       var barra = document.querySelector('[data-euf]');

   ma sections/eu-collezione.liquid rende il filtro DUE volte: prima dentro
   .euc__mobile (il pannello a fisarmonica del telefono) e subito dopo dentro
   .euc__desktop. querySelector prende il primo, che nell'ordine del DOM e'
   sempre quello mobile — nascosto su schermo largo. I filtri che l'utente
   vede davvero, quelli desktop, non ricevevano nessun ascoltatore.

   Qui si aggancia il comportamento a TUTTI i contenitori [data-euf], tenendo
   i gruppi separati per contenitore: chiudere un filtro desktop non deve
   toccare la copia mobile e viceversa.

   Restano le due regole gia' volute nell'originale: l'esclusione vale solo
   sopra i 900px, dove i pannelli galleggiano (sotto stanno nel flusso e
   chiuderli farebbe saltare la pagina sotto il dito), e Esc chiude riportando
   il fuoco sul pulsante del filtro.

   Quando l'originale verra' corretto in eu-filtri.liquid, questo blocco va
   tolto: la guardia __eufPannelli dello snippet e questa qui sono distinte,
   quindi finche' convivono i due script si sommano senza rompersi.
   -------------------------------------------------------------------------- */
(function () {
  if (window.__eurekaFiltriFix) return;
  window.__eurekaFiltriFix = true;

  function avvia() {
    var barre = document.querySelectorAll('[data-euf]');
    if (!barre.length) return;

    var galleggiano = window.matchMedia('(min-width: 900px)');

    Array.prototype.forEach.call(barre, function (barra) {
      var gruppi = Array.prototype.slice.call(barra.querySelectorAll('.euf__g'));
      if (gruppi.length < 2) return;

      gruppi.forEach(function (g) {
        g.addEventListener('toggle', function () {
          if (!g.open || !galleggiano.matches) return;
          gruppi.forEach(function (altro) {
            if (altro !== g && altro.open) altro.open = false;
          });
        });
      });
    });

    /* Clic fuori: chiude qualunque pannello aperto, in tutti i contenitori. */
    document.addEventListener('click', function (e) {
      if (!galleggiano.matches) return;
      if (e.target.closest && e.target.closest('.euf__g')) return;
      Array.prototype.forEach.call(
        document.querySelectorAll('.euf__g[open]'),
        function (g) { g.open = false; }
      );
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var aperto = document.querySelector('.euf__g[open]');
      if (!aperto) return;
      aperto.open = false;
      var bottone = aperto.querySelector('.euf__t');
      if (bottone) bottone.focus();
    });
  }

  /* Con defer il DOM c'e' gia', ma la guardia serve se un giorno il file
     venisse caricato in modo diverso. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
